import React from 'react'
import { shield } from 'react-icons-kit/fa/shield'
import { ic_check_circle } from 'react-icons-kit/md/ic_check_circle'
import { Link } from 'react-router-dom'
import Icon from 'react-icons-kit'

import './UserLink.css'

let UserLink = ({ username, premium, moderator, admin }) => <span className='userlink'>
	<Link to={`/u/${username}/`}>
		<span className={'userlink_username'}>
			{premium && <Icon className='userlink_premium_icon' size={15} icon={ic_check_circle} />}
			{username} {moderator && <Icon className='userlink_staff_icon' size={12} icon={shield} />}
		</span>
	</Link>
	{admin && <span className='userlink_admin'>admin</span>}
</span>

export default UserLink